import { useMutation } from 'react-query'

import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'
import { scanService } from 'src/services/scan.service'
import { EScanRecordType, IScanCreateForm } from 'src/types'

type Props = IScanCreateForm & {
  record_type: EScanRecordType
}

export const useAddDraftScan = () => {
  return useMutation(async ({ media, ...dto }: Props) => {
    const uploadedMedia = await mediaEntityUploadService.uploadMedia(media)

    return scanService.createDraftScan({
      ...dto,
      media: uploadedMedia,
    })
  })
}
